<script>
import Drawer from "vue-simple-drawer";
import {toPlural} from "@/helpers/utils";

export default {
  props: {
    value: Object,
    resourceName: {
      type: String,
      required: true
    },
    showAdvancedSearch: {
      type: Boolean,
      default: false
    }
  },
  components: {Drawer},
  data() {
    return {
      localResourceNamePlur: toPlural(this.resourceName),
      advancedSearchFields: {},
      showAdvancedSearchLocal: this.showAdvancedSearch,
      localValue: {
        fieldsForAdvancedSearch: this.value
      }
    };
  },
  watch: {
    showAdvancedSearch: function (val) {
      this.showAdvancedSearchLocal = val
    },
    localValue: function (val) {
      this.$emit('input', val.fieldsForAdvancedSearch)
    },
  },
  computed: {
    loadComponentAdvancedSearch() {
      return () => import(`../../components/${this.localResourceNamePlur}/${this.resourceName}-advanced-search`);
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    toggleAdvancedSearch() {
      this.showAdvancedSearchLocal = !this.showAdvancedSearchLocal;
    },
    advancedSearchTrigger() {
      this.$emit('submit');
    },
    resetAdvancedSearch() {
      this.localValue = {
        fieldsForAdvancedSearch: null,
        fieldsForLocalState: null,
      }
      this.$emit('reset');
    },
  }
};
</script>

<template>
  <Drawer @close="close" :align="'left'" :closeable="true" :maskClosable="true" :zIndex="4" :mask="false">
    <div v-if="showAdvancedSearchLocal">
      <div class="offcanvas-header w-100 d-block">
        <h5 class="offcanvas-title text-uppercase">
          {{ $t('general.advanced-search') }}
          <small class="text-lowercase text-info float-end" role="button" @click="resetAdvancedSearch"> {{ $t('general.reset') }}</small>
        </h5>
      </div>
      <div class="offcanvas-body overflow-visible">
        <keep-alive>
          <component
              :is="loadComponentAdvancedSearch"
              v-model="localValue"
          ></component>
        </keep-alive>
      </div>
      <div class="offcanvas-bottom h-auto float-end">
        <label class="d-inline-flex align-items-center text-capitalize mb-0">
          <b-button class="form-control form-control-sm ms-2" @click="advancedSearchTrigger">
            {{ $t('general.search') }}
          </b-button>
        </label>
      </div>
    </div>
  </Drawer>
</template>
